export default "__VITE_ASSET__BniPuafr__"